<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      @if (isLoading) {
        <div class="loading loading-center"></div>
      }
      @else {
        <div class="d-flex flex-column align-items-center justify-content-center my-5">
          <img src="assets/icons/header_logo.svg" alt="Logo" />
          <img src="assets/icons/header_title.svg" alt="Mercedes-Benz" class="d-block mt-4"/>
        </div>
        <div class="images-container row no-gutters">
          <a
            (click)="generateUrl()"
            class="position-relative col-12 col-md-6 pr-0 pr-md-3"
            [class.tile-loading]="isGeneratingMKHUrl"
            [class.tile-disabled]="hasForwardPreference"
          >
            <img src="assets/images/start_mar20x.jpg" srcset="assets/images/start_mar20x@2x.jpg" alt="MAR20X image">
            @if (isGeneratingMKHUrl) {
              <div class="loading loading-center"></div>
            }
          </a>
          <a
            routerLink="/home"
            (click)="savePreferences()"
            class="col-12 col-md-6 pl-0 pl-md-3"
            [class.tile-disabled]="isGeneratingMKHUrl"
          >
            <img src="assets/images/start_dep.jpg" srcset="assets/images/start_dep@2x.jpg" alt="DEP image">
          </a>
        </div>
        <div class="text-right my-3">
          <label class="font-weight-normal">
            <input
              type="checkbox"
              name="Preferences"
              [(ngModel)]="hasForwardPreference"
              style="vertical-align: -3px;"
            >
            <span class="ml-2">{{ 'START.FORWARD_TO_DEP' | transloco }}</span>
          </label>
        </div>
      }
    </div>
  </div>
</div>
